import React, { useEffect } from "react";
import { Modal, Form, Select, Button } from "antd";
import { useGlobalContext } from "../../context/GlobalContext";
import toast from "react-hot-toast";
import useGet from "../common/useGet";
import {
  API_CUSTOMER_CONFIGURABLE_MERCHANTS,
  API_GENERATE_API_KEY,
} from "../../utils/apis";
import useSet from "../common/useSet";

const GenerateApiKey: React.FC = () => {
  const { data: globalData, updateData } = useGlobalContext();
  const { openGenerateApiKey } = globalData || {};
  const [form] = Form.useForm();
  const { data: merchantsData, loadData, loading: merchantsLoading } = useGet();
  const {
    uploadData,
    submitting,
    error: submitError,
    success: submitSuccess,
    data: responseData,
  } = useSet();

  useEffect(() => {
    if (openGenerateApiKey) {
      loadData({ api: API_CUSTOMER_CONFIGURABLE_MERCHANTS });
    }
  }, [openGenerateApiKey]);

  useEffect(() => {
    if (submitSuccess && responseData) {
      toast.success("API key generated successfully");
      updateData({ openGenerateApiKey: false });
      form.resetFields();
    }
  }, [submitSuccess, responseData]);

  useEffect(() => {
    if (
      submitError &&
      Object.keys(submitError).length > 0 &&
      !submitError.notSubmit
    ) {
      const errorMessage =
        (typeof submitError?.message === "string"
          ? submitError.message
          : null) ||
        (typeof submitError?.detail === "string" ? submitError.detail : null) ||
        "Failed to generate API key";
      toast.error(errorMessage);
    }
  }, [submitError]);

  const handleClose = () => {
    updateData({ openGenerateApiKey: false });
    form.resetFields();
  };

  const handleSubmit = (values: any) => {
    uploadData({
      api: API_GENERATE_API_KEY,
      data: {
        merchant_number: values.merchantId,
      },
    });
  };

  return (
    <Modal
      open={!!openGenerateApiKey}
      onCancel={handleClose}
      title="Generate Encryption Key"
      footer={null}
      centered
      width={500}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        autoComplete="off"
      >
        <Form.Item
          label="Merchant"
          name="merchantId"
          rules={[{ required: true, message: "Please select a merchant" }]}
        >
          <Select
            placeholder="Select merchant"
            size="large"
            loading={merchantsLoading}
            showSearch
            filterOption={(input, option) =>
              String(option?.label ?? "")
                .toLowerCase()
                .includes(input.toLowerCase())
            }
            options={merchantsData?.map((merchant: any) => ({
              value: merchant.id,
              label: merchant.name,
            }))}
          />
        </Form.Item>

        <Form.Item style={{ marginBottom: 0, marginTop: 24 }}>
          <div style={{ display: "flex", gap: 12, justifyContent: "flex-end" }}>
            <Button onClick={handleClose} size="large">
              Cancel
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              loading={submitting}
              size="large"
            >
              Generate Key
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default GenerateApiKey;
